export default {"src":"/sitetest/_next/static/media/top_icon_active.f2b0eb40.svg","height":49,"width":49,"blurWidth":0,"blurHeight":0};